import React, { useState } from 'react';
import _get from 'lodash/get';
import { BeaconChartWithLegendProps } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconChartWithLegend';
import { BeaconDropdownMetricColumnChartProps } from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import AtlasV2MetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2MetricColumnChart';

/**
 * Shows a column chart with a dropdown that will change the
 * group by field
 */
export default function AtlasV2DropdownMetricColumnChart(props: BeaconDropdownMetricColumnChartProps) {
  const { defaultOptionId, dropdownOptions, useAdvancedSearchDataArgs, titlePrefix, fieldName, indexName } = props;
  const [selectedId, setSelectedId] = useState(defaultOptionId || _get(dropdownOptions, [0, 'id']));

  return (
    <AtlasV2MetricColumnChart
      {...props}
      indexName={typeof indexName === 'function' ? indexName({ selectedDropdownId: selectedId }) : indexName}
      useAdvancedSearchDataArgs={{
        groupByField: selectedId,
        fields: [{ name: fieldName }],
        ...useAdvancedSearchDataArgs
      }}
      beaconChartWithLegendPropsBuilder={(defaultChartProps) => {
        const chartProps: Omit<BeaconChartWithLegendProps, 'children'> = {
          ...defaultChartProps,
          singleDropdownProps: {
            ...defaultChartProps.singleDropdownProps,
            prefix: titlePrefix,
            defaultLabel: '',
            options: dropdownOptions,
            selectedId,
            onChange: (option) => {
              setSelectedId(option.id);
            }
          }
        };

        return props.beaconChartWithLegendPropsBuilder
          ? props.beaconChartWithLegendPropsBuilder(chartProps)
          : chartProps;
      }}
    />
  );
}
